"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridPower = exports.shaftPower = exports.pressure = exports.airFlow = exports.actualDensity = exports.airInputsMassflow = exports.airInputsPressure = exports.airInputsHumidity = exports.airInputsTemperature = exports.altitude = exports.targetPressure = exports.fanMaximumSpeed = exports.fanMinimumSpeed = exports.motorInputPower = exports.motorCosphi = exports.motorGridPowerExponent = exports.motorPoles = exports.motorPhases = exports.motorVoltage = exports.fanDynamicPressureLossCoefficient = exports.fanOutletArea = exports.fanDefinitionStandardDensity = exports.fanDefinitionSpeed = exports.fanQuantity = exports.fanControlMode = void 0;
exports.fanControlMode = "fptcontrolmode";
exports.fanQuantity = "fptfanquantity";
exports.fanDefinitionSpeed = "fptfandefinitionspeed";
exports.fanDefinitionStandardDensity = "fptfandefinitionstandarddensity";
exports.fanOutletArea = "fptfanoutletarea";
exports.fanDynamicPressureLossCoefficient = "fptfandynamicpressurelosscoefficient";
exports.motorVoltage = "fptmotorvoltage";
exports.motorPhases = "fptmotorphases";
exports.motorPoles = "fptmotorpoles";
exports.motorGridPowerExponent = "fptmotorgridpowerexponent";
exports.motorCosphi = "fptmotorcosphi";
exports.motorInputPower = "fptmotorinputpower";
exports.fanMinimumSpeed = "fptfanminimumspeed";
exports.fanMaximumSpeed = "fptfanmaximumspeed";
exports.targetPressure = "targetpressure";
exports.altitude = "altitude";
exports.airInputsTemperature = "airinputstemperature";
exports.airInputsHumidity = "airinputshumidity";
exports.airInputsPressure = "airinputspressure";
exports.airInputsMassflow = "airinputsmassflow";
exports.actualDensity = "actualdensity";
exports.airFlow = "airflow";
exports.pressure = "pressure";
exports.shaftPower = "shaftpower";
exports.gridPower = "gridpower";
//# sourceMappingURL=known-properties.js.map